import {
  NotificationContext,
  type NotificationContextType,
} from 'components/organisms/Notification/NotificationContext';
import { useContext } from 'react';

export const useNotification = (): NotificationContextType | undefined =>
  useContext(NotificationContext);
